import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  max-width: 840px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  align-self: center;
  height: 100%;

  & > :first-child {
    margin-bottom: 0 !important;
  }
`;
